var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("h3", [_vm._v("商户详情")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-actions" },
              [
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.goBack } },
                  [_vm._v("返回列表")]
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "detail-content",
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 16 } }, [
                  _c("div", { staticClass: "info-section" }, [
                    _c("h4", { staticClass: "section-title" }, [
                      _vm._v("基本信息"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-grid" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("商户ID：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.merchantDetail.merchantId || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("商户名称：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.merchantDetail.merchantName || "-")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("归属公司：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.merchantDetail.companyName ||
                                _vm.merchantDetail.company ||
                                "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "info-item" },
                        [
                          _c("label", [_vm._v("合作状态：")]),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getStatusType(
                                  _vm.merchantDetail.cooperationStatus
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.getCooperationStatusName(
                                      _vm.merchantDetail.cooperationStatus
                                    ) || "-"
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("开票方式：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getInvoiceMethodName(
                                _vm.merchantDetail.invoiceMethod
                              ) || "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("维护人：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.merchantDetail.maintainerName ||
                                _vm.merchantDetail.maintainer ||
                                "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("负责人：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.merchantDetail.leader || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("负责人电话：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.merchantDetail.leaderPhone || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("数据来源：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.merchantDetail.dataSource || "-")),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-section" }, [
                    _c("h4", { staticClass: "section-title" }, [
                      _vm._v("联系信息"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-grid" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("对接人：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.merchantDetail.contactPerson || "-")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("对接人电话：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.merchantDetail.contactPhone || "-")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("微信群名称：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.merchantDetail.wechatGroupName || "-")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("财务联系人：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.merchantDetail.finance || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("财务电话：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.merchantDetail.financePhone || "-")
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-section" }, [
                    _c("h4", { staticClass: "section-title" }, [
                      _vm._v("公司信息"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-grid" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("统一社会信用代码：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.merchantDetail.socialCreditCode || "-")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("供应商别名：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.merchantDetail.abbreviation || "-")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("公司地址：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.merchantDetail.address || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.merchantDetail.synopsis
                        ? _c("div", { staticClass: "info-item" }, [
                            _c("label", [_vm._v("简介：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.merchantDetail.synopsis)),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-section" }, [
                    _c("h4", { staticClass: "section-title" }, [
                      _vm._v("财务信息"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-grid" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("label", [_vm._v("调价方式：")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.getAdjustTypeName(_vm.merchantDetail.isAdjust)
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.merchantDetail.isAdjust === 1
                        ? _c("div", { staticClass: "info-item" }, [
                            _c("label", [_vm._v("调价范围：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.getAdjustRangeName(
                                    _vm.merchantDetail.adjustType
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.merchantDetail.isAdjust === 1
                        ? _c("div", { staticClass: "info-item" }, [
                            _c("label", [_vm._v("调价比例：")]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatAdjustRate(
                                    _vm.merchantDetail.adjustRate
                                  )
                                )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.merchantDetail.remark
                    ? _c("div", { staticClass: "info-section" }, [
                        _c("h4", { staticClass: "section-title" }, [
                          _vm._v("备注信息"),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "remark-text" }, [
                          _vm._v(_vm._s(_vm.merchantDetail.remark)),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "sidebar-section" }, [
                    _c("h4", { staticClass: "section-title" }, [
                      _vm._v("商户LOGO"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "logo-display" }, [
                      _vm.merchantDetail.logo
                        ? _c("img", {
                            staticClass: "merchant-logo",
                            attrs: {
                              src: _vm.merchantDetail.logo,
                              alt: "商户LOGO",
                            },
                          })
                        : _c("div", { staticClass: "no-logo" }, [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" "),
                            _c("p", [_vm._v("暂无LOGO")]),
                          ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sidebar-section" }, [
                    _c("h4", { staticClass: "section-title" }, [
                      _vm._v("营业执照"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "license-display" }, [
                      _vm.merchantDetail.businessLicense
                        ? _c("img", {
                            staticClass: "business-license",
                            attrs: {
                              src: _vm.merchantDetail.businessLicense,
                              alt: "营业执照",
                            },
                          })
                        : _c("div", { staticClass: "no-license" }, [
                            _c("i", { staticClass: "el-icon-document" }),
                            _vm._v(" "),
                            _c("p", [_vm._v("暂无营业执照")]),
                          ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sidebar-section" }, [
                    _c("h4", { staticClass: "section-title" }, [
                      _vm._v("操作记录"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "operation-log" }, [
                      _c("div", { staticClass: "log-item" }, [
                        _c("span", { staticClass: "log-time" }, [
                          _vm._v(_vm._s(_vm.merchantDetail.createTime)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "log-action" }, [
                          _vm._v("创建商户"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "log-user" }, [
                          _vm._v(_vm._s(_vm.merchantDetail.creator)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.merchantDetail.updateTime
                        ? _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-time" }, [
                              _vm._v(_vm._s(_vm.merchantDetail.updateTime)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "log-action" }, [
                              _vm._v("更新信息"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "log-user" }, [
                              _vm._v(_vm._s(_vm.merchantDetail.updater)),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }